<template>
    <div class="flex items-center">
        <button class="flex sacclist-row-button" title="Ny faktura" @click="showInvoiceCreator">
            <i class="i-mdi-format-list-group-plus text-lg text-base-content/50 hover:text-base-content mt-1"/>
        </button>
    </div>
</template>

<script setup lang="ts">
import {SubAccount} from '@/subaccount/types/SubAccount'
import {computed, Ref} from 'vue'
import {useTargetingLinkService} from '@tritt/multipanel'
import {useInvoiceCreator} from '@/invoice/invoice.service'
import {usePanelManager} from '@tritt/multipanel'
import {INVOICE_CREATOR} from '@/invoice'

const props = defineProps({
    params: {
        type: Object as () => {
            data: SubAccount,
            context: {
                panelId: Ref<number>
            }
        },
        required: true
    }
})

const subAccount = computed<SubAccount>(() => props.params.data)

const currentPanel = props.params.context.panelId

const showInvoiceCreator = () => {
    const {targetPanel} = useTargetingLinkService()
    const {invoiceData} = useInvoiceCreator()
    invoiceData.value.customer = subAccount.value
    const {setPanelPath} = usePanelManager()
    setPanelPath({
        ...INVOICE_CREATOR,
        panelId: targetPanel.value || currentPanel.value
    })
}

</script>

<style scoped>

</style>